define(['../services/campaigns', '../../lead/services/leads'], function () {
    'use strict';

    return {
        name: 'campaignsCtrl',
        arguments: [
            '$scope',
            '$state',
            '$stateParams',
            'ErrorHandler',
            'FileUpload',
            'Campaigns',
            'Leads',
            'Profile',
            'Site',
            function (
                $scope,
                $state,
                $stateParams,
                ErrorHandler,
                FileUpload,
                Campaigns,
                Leads,
                Profile,
                Site
            ) {
                $scope.compactView = false;
                $scope.currentCampaign = Campaigns.newCampaign();
                $scope.campaigns = Campaigns.getCampaigns();
                $scope.campaignCounts = Campaigns.getCounts();
                $scope.leads = Leads.getLeads();
                $scope.user = Profile.getProfile();
                $scope.sendToAll = true;
                $scope.sendToLeads = [];
                $scope.site = Site.getSite();

                if ($stateParams) {
                    if ($stateParams.campaign) {
                        $scope.campaigns.$promise.then(function () {
                            angular.forEach($scope.campaigns, function (
                                campaign
                            ) {
                                if (campaign.id == $stateParams.campaign) {
                                    $scope.currentCampaign = campaign;
                                }
                            });
                        });
                    }
                }

                $scope.deleteCurrentCampaign = function () {
                    Campaigns.deleteCampaign(
                        $scope.currentCampaign,
                        function () {
                            Campaigns.updateCounts();
                            $state.go('campaigns.list');
                        }
                    );
                };

                $scope.campaignOrder = 'when';
                $scope.getCampaignOrder = function () {
                    switch ($scope.campaignOrder) {
                        case 'when':
                            return ['triggerDays', 'trigger'];
                            break;
                        case '-when':
                            return ['-triggerDays', '-trigger'];
                            break;
                    }
                    return $scope.campaignOrder;
                };

                $scope.setCurrentCampaign = function (campaign) {
                    $scope.currentCampaign = campaign;
                };

                $scope.saveCurrentCampaign = function (
                    campaignForm,
                    audioFile
                ) {
                    campaignForm.serverErrors = '';
                    campaignForm.submitted = true;
                    if (campaignForm.$valid) {
                        var success = true;
                        $scope.currentCampaign
                            .save()
                            .catch(function (result) {
                                if (campaignForm) {
                                    campaignForm.serverErrors = ErrorHandler.getMessage(
                                        result,
                                        'Error saving campaign.  Please try again'
                                    );
                                    console.log(campaignForm.serverErrors);
                                }
                                success = false;
                            })
                            .then(function (result) {
                                if (success) {
                                    if ($scope.campaigns) {
                                        $scope.campaigns.$promise.then(
                                            function () {
                                                var exists = false;
                                                angular.forEach(
                                                    $scope.campaigns,
                                                    function (data) {
                                                        if (
                                                            data.id ==
                                                            $scope
                                                                .currentCampaign
                                                                .id
                                                        ) {
                                                            exists = true;
                                                        }
                                                    }
                                                );
                                                if (!exists) {
                                                    $scope.campaigns.push(
                                                        $scope.currentCampaign
                                                    );
                                                }
                                            }
                                        );
                                    }
                                    if (campaignForm) {
                                        campaignForm.submitted = false;
                                        campaignForm.serverErrors = null;
                                    }
                                    Campaigns.updateCounts();
                                    if (!audioFile) {
                                        $state.go('campaigns.list');
                                    }
                                }
                            });
                    }
                };

                $scope.sendCurrentCampaign = function (campaignForm) {
                    $scope.sendingResults = {};
                    campaignForm.submitted = true;
                    if (campaignForm.$valid) {
                        $scope.buttonText = 'Sending...';
                        var success = true;
                        var data = {};
                        if ($scope.currentCampaign.id) {
                            data.id = $scope.currentCampaign.id;
                        } else {
                            data.campaign = $scope.currentCampaign;
                        }
                        if (!$scope.sendToAll) {
                            data.sendTo = $scope.sendToLeads;
                        }
                        Campaigns.sendCampaign(data)
                            .$promise.catch(function (result) {
                                if (campaignForm) {
                                    campaignForm.serverErrors = ErrorHandler.getMessage(
                                        result,
                                        'Error sending.  Please try again'
                                    );
                                    if (
                                        $scope.currentCampaign.campaign_type ==
                                        'sms'
                                    ) {
                                        $scope.buttonText = 'Send Text';
                                    } else {
                                        $scope.buttonText = 'Send Email';
                                    }
                                }
                                success = false;
                            })
                            .then(function (result) {
                                if (success) {
                                    $scope.sendingResults = result;
                                    $state.go('campaigns.list');
                                }
                            });
                    }
                };

                $scope.toggleSendTo = function (lead) {
                    var i = $scope.sendToLeads.indexOf(lead.id);
                    if (i > -1) {
                        $scope.sendToLeads.splice(i, 1);
                    } else {
                        $scope.sendToLeads.push(lead.id);
                    }
                };

                $scope.searchCampaigns = function (campaign) {
                    const query = ($scope.searchQuery || '').toLowerCase();
                    return (
                        (campaign.subject &&
                            campaign.subject.toLowerCase().includes(query)) ||
                        (!campaign.subject &&
                            campaign.body &&
                            campaign.body.toLowerCase().includes(query)) ||
                        campaign.formattedTrigger.toLowerCase().includes(query)
                    );
                };

                $scope.characterCount = function () {
                    if ($scope.currentCampaign.body) {
                        return (
                            $scope.currentCampaign.body.replace(
                                /\{ ?\$name ?\}/g,
                                ''
                            ).length +
                            (
                                $scope.currentCampaign.body.match(
                                    /\{ ?\$name ?\}/g
                                ) || []
                            ).length *
                                15
                        );
                    }
                    return 0;
                };
            },
        ],
    };
});
